import * as constants from './constants';

/* Get payment methods */
export const getPaymentMethods = (projectId) => ({
  type: constants.GET_PAYMENT_METHODS,
  projectId
});

export const getPaymentMethodsSuccess = (projectId, paymentMethods) => ({
  type: constants.GET_PAYMENT_METHODS_SUCCESS,
  projectId,
  paymentMethods
});

export const getPaymentMethodsError = (projectId, error) => ({
  type: constants.GET_PAYMENT_METHODS_ERROR,
  projectId,
  error
});

/* Add payment method */
export const addPaymentMethod = (projectId, handleCardSetup, actions) => ({
  type: constants.ADD_PAYMENT_METHOD,
  projectId,
  handleCardSetup,
  actions
});

export const addPaymentMethodSuccess = (projectId) => ({
  type: constants.ADD_PAYMENT_METHOD_SUCCESS,
  projectId
});

export const addPaymentMethodError = (projectId, error) => ({
  type: constants.ADD_PAYMENT_METHOD_ERROR,
  projectId,
  error
});

/* Delete payment method */
export const deletePaymentMethod = (projectId, paymentMethodId) => ({
  type: constants.DELETE_PAYMENT_METHOD,
  projectId,
  paymentMethodId
});

export const deletePaymentMethodSuccess = (projectId) => ({
  type: constants.DELETE_PAYMENT_METHOD_SUCCESS,
  projectId
});

export const deletePaymentMethodError = (
  projectId,
  paymentMethodId,
  error
) => ({
  type: constants.DELETE_PAYMENT_METHOD_ERROR,
  projectId,
  paymentMethodId,
  error
});
